import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { setLanguage as applyLanguage, type Language, SUPPORTED_LANGUAGES } from '.';

export function useLanguage() {
	const { i18n } = useTranslation();
	const setLanguage = useCallback((language: Language) => {
		void applyLanguage(language);
	}, []);
	return { language: (i18n.resolvedLanguage ?? 'en') as Language, setLanguage, languages: SUPPORTED_LANGUAGES };
}
